// extracted by mini-css-extract-plugin
export var button = "_iz-0";
export var donut = "_iz-1";
export var donutFill = "_iz-3";
export var donutTrack = "_iz-2";